import Com from "components/styledComp/CommStyledComp";
import React, { useState } from "react";
import 에스마리나_표 from "assets/images/에스마리나_표.png"
import CompImg from "./CompImg";
import Modal from "./Modal";

const Competitors = () => {

    const [showModal, setShowModal] = useState(false);

    const handleImgClick = () => {
        setShowModal(true);
    };

    return(
        <Com.DivDetailSection3 border={"true"}>
            <div className="strategy">
                <Com.StrongStrategyCenter>경쟁사/경쟁 우위</Com.StrongStrategyCenter>
                <CompImg img={에스마리나_표} width="100%" height="auto" onClick={handleImgClick}/>
            </div>
            <div className="pedestal-descbox">
                <div className="pedestal-parabox">
                    <ul>
                        <li>제조사와 무관한 Pedestal 원격 제어시스템 및 마리나 관리시스템</li>
                        <li>다양한 마리나 운영 데이터의 추출(Customizing)</li>
                        <li>완벽한 한글 지원(SMS), Manual, 화면 구성</li>
                        <li>조명, 출입문 제어 등 필수 기능 추가</li>
                        <li>별도의 RFID 카드가 필요 없어도 Mobile 장치를 통한 Pedestal 제어</li>
                    </ul>
                </div>
            </div>
            {showModal && (
                <Modal onClose={() => setShowModal(false)}>
                    <img src={에스마리나_표} alt="Full" style={{ width: "100%" }} />
                </Modal>
            )}
        </Com.DivDetailSection3>
    );
}

export default Competitors;